import {FeedbackReducerActionType, useFeedbackDispatch} from "../../utils/FeedbackContext";
import {useEffect, useRef, useState} from "react";
import {getDashboardDetails} from "../../api/RestCallHelper";
import {useHistory, useLocation} from "react-router-dom";
import FetchState from "../../api/FetchState";

export function useFetchDashboardData() {

    let history = useHistory();
    let location = useLocation();

    const [fetchState, setFetchState] = useState(FetchState.LOADING);
    const dispatch = useFeedbackDispatch();

    const [data, setData] = useState([]);
    const [isSending, setIsSending] = useState(false);
    const isMounted = useRef(true);

    const close = (event, reason) => {
        console.log("In useFetchDashboardData close callback");
        if (reason === 'clickaway') return;

        dispatch({type: FeedbackReducerActionType.CLOSE_FEEDBACK});
    };

    useEffect(() => {

        // don't send again while we are sending
        if (isSending) return;

        // update state
        setIsSending(true);

        getDashboardDetails(setData, setFetchState, dispatch, close, history, location);

        // once the request is sent, update state again
        if (isMounted.current)
            // only update if we are still mounted
            setIsSending(false);

    }, [setData, setIsSending]);

    return [data, fetchState];

}